import { CloseRounded } from '@mui/icons-material'
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'
import { colors } from '../theme'

interface OverviewFilterDialogProps {
  open: boolean
  onClose: () => void
  title?: string
  children: ReactNode
}

export const OverviewFilterDialog: FC<OverviewFilterDialogProps> = ({ open, onClose, title = 'Filtres', children }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle sx={{ px: { xs: 2, sm: 3 }, py: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Box>
            <Typography sx={{ color: colors.cello, fontSize: '1.25rem', fontWeight: 700 }}>{title}</Typography>
            <Typography sx={{ color: '#7A8197', fontSize: '0.92rem' }}>
              Ajustez l&apos;affichage sans surcharger la page.
            </Typography>
          </Box>
          <IconButton onClick={onClose} sx={{ color: '#7A8197' }}>
            <CloseRounded />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 3 } }}>{children}</DialogContent>

      <Box sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 3 }, pt: 0 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            textTransform: 'none',
            borderRadius: '999px',
            px: 3,
            fontWeight: 700,
            boxShadow: 'none',
          }}
        >
          Voir le resultat
        </Button>
      </Box>
    </Dialog>
  )
}

interface OverviewFilterSectionProps {
  children: ReactNode
}

export const OverviewFilterSection: FC<OverviewFilterSectionProps> = ({ children }) => {
  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: '#F8F9FC',
        border: '1px solid #E4E8F2',
        borderRadius: 3,
      }}
    >
      {children}
    </Box>
  )
}
